import request from "@/utils/request.js"

// 教练列表
export const listCoach = (pageData, formData) => {
    return request.get(`/coach/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 新增教练
export const addCoach = (updateData) => {
    return request.post(`/coach`, updateData)
}

// 修改教练信息
export const editCoach = (id, updateData) => {
    return request.put(`/coach`, updateData)
}

// 教练详情
export const getCoach = (id) => {
    return request.get(`/coach/${id}`)
}

// 删除教练
export const deleteCoach = (id) => {
    return request.delete(`/coach/${id}`)
}

// 修改教练状态
export const changeCoachState = (id, state) => {
    return request.put(`/coach/${id}/${state}`)
}
